import { useNavigate } from 'react-router-dom'

import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { WorkSpaceNode } from 'modules/space_control/hooks/useWorkSpaces'

import DeleteModal from './DeleteModal'

interface PropsWorkSpace {
  locationId: string
  workAreaId: string
  workSpace: WorkSpaceNode
  canEditSpace: boolean
  canDeleteSpace: boolean
  onDeleteSuccess: () => void
}

const Options = ({
  locationId,
  workAreaId,
  workSpace,
  canEditSpace,
  canDeleteSpace,
  onDeleteSuccess,
}: PropsWorkSpace) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [deleteModalOpen, toggleDeleteModal] = useToggle(false)

  const editWorkSpace = () => {
    track(trackingEvents.spaceControl.editSpace, {})

    const navigationParams = {
      id: locationId,
      workAreaId: workAreaId,
      workSpaceId: workSpace.id ? workSpace.id.toString() : '',
    }

    navigate(
      navigation.settings.locations.locationsId.workAreas.workSpaces.editWorkSpace.fullPath(
        navigationParams
      )
    )
  }

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger>
          <Button.Decorative type="secondary" iconName="ellipsis" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          {canEditSpace && (
            <PopoverMenu.TouchableOption
              onClick={editWorkSpace}
              title={i18n.t('settings.locations.location.work_spaces.edit.title')}
            />
          )}
          {canDeleteSpace && (
            <PopoverMenu.TouchableOption
              onClick={toggleDeleteModal(true)}
              title={i18n.t('settings.locations.location.work_spaces.delete')}
              danger
            />
          )}
        </PopoverMenu.Content>
      </PopoverMenu>
      {deleteModalOpen && (
        <DeleteModal
          toggleModal={toggleDeleteModal(false)}
          workSpace={workSpace}
          onSuccess={onDeleteSuccess}
        />
      )}
    </Box>
  )
}

export default observer(Options)
